import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import Seo from './Seo';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import PageAtmosphere from './PageAtmosphere';
import { getPostBySlug } from './blogPosts';
import './Marketing.css';

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return iso;
  }
}

function renderBlock(block, idx) {
  if (block.type === 'h2') {
    return <h2 key={idx}>{block.text}</h2>;
  }
  if (block.type === 'ul') {
    return (
      <ul key={idx}>
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  return <p key={idx}>{block.text}</p>;
}

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="marketing-page marketing-page--atmosphere">
      <Seo title={`${post.title} — 3AM AI`} description={post.description} path={`/blog/${post.slug}`} />
      <PageAtmosphere variant="subtle" />
      <SiteNav />
      <main>
        <article className="blog-post">
          <header className="blog-post__header m-animate-in">
            <p className="blog-post__meta">
              <Link to="/blog">Blog</Link>
              <span aria-hidden="true"> · </span>
              <span>{post.category}</span>
              <span aria-hidden="true"> · </span>
              <time dateTime={post.date}>{formatDate(post.date)}</time>
              <span aria-hidden="true"> · </span>
              <span>{post.readTime}</span>
            </p>
            <h1>{post.title}</h1>
            <p className="blog-post__dek">{post.description}</p>
          </header>
          <div className="blog-post__body m-animate-in m-animate-in--delay-1">
            {post.body.map(renderBlock)}
          </div>
          <aside className="blog-post__cta m-animate-in m-animate-in--delay-2">
            <h2>Try Life Journal</h2>
            <p>
              Write it down, track your mood, set a goal, and think it through with 3AM AI&apos;s calm
              coach.
            </p>
            <div className="m-btn-row">
              <Link to="/signup" className="m-btn m-btn--primary">
                Start free
              </Link>
              <Link to="/product#journey" className="m-btn m-btn--ghost">
                How it works
              </Link>
            </div>
          </aside>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
